module.exports = "'data:image/svg+xml;utf8,<svg width=\"7\" height=\"12\" viewBox=\"0 0 7 12\" xmlns=\"http://www.w3.org/2000/svg\"><title>arrow</title><path d=\"M4.309 6.103l-3.98-3.98A1.128 1.128 0 0 1 .331.535 1.12 1.12 0 0 1 1.92.532L6.698 5.31c.216.216.325.503.326.79.002.292-.108.578-.326.796L1.92 11.674a1.128 1.128 0 0 1-1.589-.002 1.12 1.12 0 0 1-.002-1.589l3.98-3.98z\" fill=\"%23DADDD6\" fill-rule=\"evenodd\"/></svg>'"


//////////////////
// WEBPACK FOOTER
// ./src/Components/SampleToggle/arrowCollapsed.svg
// module id = 658
// module chunks = 0